// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { FileType } from "..";
import { dispatchNotificationEvent } from "../NotificationSystem/utils";
import { addRepresentation } from "../3dViewer/showFile";
import { findSystemByKey, updateStateTreeRepresentation, } from "../3dViewer/stateTree";
import { getActiveSystemEntries } from "../utils/IndexSelector/indexSelectorToIndexArray";
import { removeRepresentation } from "../3dViewer/Controls/utils";
import { PluginCommands } from "molstar/lib/mol-plugin/commands";
import { hexToNum } from "../3dViewer/Controls/utilsColors";
import { setVisibility } from "../3dViewer/VisibilityToggle";
import { updateStateTreeVisibilityFromCellRefs } from "../3dViewer/stateTree";
import { addEquivalentRepNewSelection, updateRepresentation, } from "../3dViewer/RepresentationControls/SelectRepresentationParam";
import { deleteEmptyMolecules } from "./deleteEmptyMolecules";
import { getSystemLoci } from "../3dViewer/Controls/getSystemLoci";
import { StateObjectRef } from "molstar/lib/mol-state/object";
import { Script } from "molstar/lib/mol-script/script";
import { StructureSelection } from "molstar/lib/mol-model/structure";
import { updateMoleculeReps } from "./updateMoleculeReps";
import { addMoleculeFromConsole } from "./addMoleculeFromConsole";
const addRep = (newRep, system, molstar, pyodide, vss) => __awaiter(void 0, void 0, void 0, function* () {
    const activeSystemEntries = getActiveSystemEntries(system);
    if (newRep.color_value) {
        newRep.color_value = hexToNum(newRep.color_value);
    }
    const addedReps = yield addRepresentation(molstar, pyodide, system.type === FileType.sdf, system.moleculeID || "", system.type === FileType.sdf, undefined, system.cellRef, system.visibility, [newRep], system.aromaticBonds, activeSystemEntries);
    const stateTreePosition = system.stateTreePosition;
    if (addedReps.length === 0 || !stateTreePosition)
        return;
    vss.getState().add_representation(stateTreePosition, addedReps[0]);
});
const removeRep = (removeIndex, system, molstar, vss) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, e_1, _b, _c, _d, e_2, _e, _f, _g, e_3, _h, _j;
    const stateTreePosition = system.stateTreePosition;
    if (!system || !system.representations || !stateTreePosition)
        return;
    if (removeIndex === undefined) {
        try {
            for (var _k = true, _l = __asyncValues(system.representations), _m; _m = yield _l.next(), _a = _m.done, !_a;) {
                _c = _m.value;
                _k = false;
                try {
                    const rep = _c;
                    if (!rep.refs)
                        continue;
                    try {
                        for (var _o = true, _p = (e_2 = void 0, __asyncValues(rep.refs)), _q; _q = yield _p.next(), _d = _q.done, !_d;) {
                            _f = _q.value;
                            _o = false;
                            try {
                                const ref = _f;
                                if (ref.repRef) {
                                    yield PluginCommands.State.RemoveObject(molstar, {
                                        state: molstar.state.data,
                                        ref: ref.repRef,
                                    });
                                }
                            }
                            finally {
                                _o = true;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (!_o && !_d && (_e = _p.return)) yield _e.call(_p);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
                finally {
                    _k = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_k && !_a && (_b = _l.return)) yield _b.call(_l);
            }
            finally { if (e_1) throw e_1.error; }
        }
        vss.getState().updateSystemParameters(stateTreePosition, {
            representations: [],
        });
    }
    else {
        if (removeIndex >= system.representations.length)
            return;
        const repToRemove = system.representations[removeIndex];
        const repRefs = [];
        if (repToRemove.refs) {
            try {
                for (var _r = true, _s = __asyncValues(repToRemove.refs), _t; _t = yield _s.next(), _g = _t.done, !_g;) {
                    _j = _t.value;
                    _r = false;
                    try {
                        const ref = _j;
                        if (ref.repRef) {
                            repRefs.push(ref.repRef);
                        }
                    }
                    finally {
                        _r = true;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (!_r && !_g && (_h = _s.return)) yield _h.call(_s);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        yield removeRepresentation(vss, molstar, repRefs, system.stateTreePosition, removeIndex);
    }
});
const updateVisibility = (system, newRep, molstar, vss, pyodide) => __awaiter(void 0, void 0, void 0, function* () {
    var _u, _v, _w, _x;
    const activeSystemEntries = getActiveSystemEntries(system);
    if (newRep.color_value) {
        newRep.color_value = hexToNum(newRep.color_value);
    }
    if ("sel" in newRep) {
        const selectedRepresentation = (_u = system.representations) === null || _u === void 0 ? void 0 : _u[newRep.index];
        const onErrorCallback = () => {
            dispatchNotificationEvent({
                message: "Error updating selection.",
                type: "error",
            });
        };
        if (selectedRepresentation &&
            system.moleculeID &&
            system.stateTreePosition) {
            for (const repParan in newRep) {
                if (repParan !== "index") {
                    selectedRepresentation[repParan] = newRep[repParan];
                }
            }
            yield addEquivalentRepNewSelection(selectedRepresentation, newRep.index, newRep["sel"], system.moleculeID, pyodide, vss, molstar, system.stateTreePosition, activeSystemEntries, onErrorCallback);
        }
    }
    else {
        if ("visibility" in newRep) {
            const repRefs = (_x = (_w = (_v = system.representations) === null || _v === void 0 ? void 0 : _v[newRep.index]) === null || _w === void 0 ? void 0 : _w.refs) === null || _x === void 0 ? void 0 : _x.map((ref) => ref.repRef).filter((ref) => ref !== undefined);
            if (repRefs) {
                setVisibility(molstar, repRefs, newRep.visibility);
                if (system.stateTreePosition)
                    updateStateTreeRepresentation(vss, system.stateTreePosition, newRep.index, {
                        visibility: newRep.visibility,
                    });
            }
        }
        const selectedRepID = newRep.index;
        const newParams = Object.fromEntries(Object.entries(newRep).filter(([key]) => key !== "index" && key !== "visibility"));
        if (Object.keys(newParams).length > 0) {
            yield updateRepresentation(molstar, system, selectedRepID, newParams);
            if (system.stateTreePosition)
                updateStateTreeRepresentation(vss, system.stateTreePosition, selectedRepID, newParams);
        }
    }
});
const deleteSystem = (system, molstar, vss, pyodide, closeSystemPanels, fromFilter, removeVisibleSystemsFiles) => __awaiter(void 0, void 0, void 0, function* () {
    const molId = system.moleculeID;
    if (!molId)
        return;
    if (!fromFilter) {
        dispatchNotificationEvent({
            type: "info",
            message: `Deleted system: ${system.name}`,
        });
    }
    deleteEmptyMolecules([molId], vss, molstar, pyodide, closeSystemPanels, removeVisibleSystemsFiles, !fromFilter);
});
const focusOnSelection = (system, molstar, focusSelection) => {
    var _a;
    const cellRefs = system.cellRef;
    if (!cellRefs || cellRefs.length === 0)
        return;
    const cellRef = cellRefs[0];
    let loci;
    if (focusSelection) {
        if (focusSelection.length === 0) {
            dispatchNotificationEvent({
                message: "Invalid selection",
                type: "error",
            });
            return;
        }
        const selectedStruct = StateObjectRef.resolveAndCheck(molstar.state.data, cellRef);
        const structureData = (_a = selectedStruct === null || selectedStruct === void 0 ? void 0 : selectedStruct.obj) === null || _a === void 0 ? void 0 : _a.data;
        if (!structureData)
            return;
        const sel = Script.getStructureSelection((Q) => Q.struct.generator.atomGroups({
            "atom-test": Q.core.set.has([
                Q.core.type.set(focusSelection),
                Q.struct.atomProperty.core.sourceIndex(),
            ]),
        }), structureData);
        loci = StructureSelection.toLociWithSourceUnits(sel);
    }
    else {
        const lociArr = getSystemLoci(cellRef, molstar);
        if (lociArr) {
            loci = lociArr[0];
        }
    }
    if (loci) {
        molstar.managers.camera.focusLoci(loci);
    }
    else {
        dispatchNotificationEvent({
            message: `Could not focus on system ${system.name}`,
            type: "error",
        });
    }
};
const systemFromMolId = (molId, vss) => {
    return findSystemByKey(vss.getState().loaded_structures, "moleculeID", molId);
};
export function updateVisualization(molId, update, molstar, pyodide, vss, closeSystemPanels, removeVisibleSystemsFiles) {
    return __awaiter(this, void 0, void 0, function* () {
        const system = systemFromMolId(molId, vss);
        if (update.action === "rep_add") {
            const newRep = update.data;
            if (!system)
                return;
            yield addRep(newRep, system, molstar, pyodide, vss);
        }
        else if (update.action === "rep_remove") {
            if (!system)
                return;
            yield removeRep(update.data, system, molstar, vss);
        }
        else if (update.action === "rep_update") {
            if (!system)
                return;
            updateVisibility(system, update.data, molstar, vss, pyodide);
        }
        else if (update.action === "syst_add") {
            try {
                yield addMoleculeFromConsole(vss, molstar, pyodide, molId);
            }
            catch (err) {
                dispatchNotificationEvent({
                    message: "Error loading new system.",
                    type: "error",
                });
            }
        }
        else if (update.action === "syst_remove") {
            if (!system)
                return;
            deleteSystem(system, molstar, vss, pyodide, closeSystemPanels, update.data, removeVisibleSystemsFiles);
        }
        else if (update.action === "syst_update") {
            try {
                yield updateMoleculeReps(vss, molstar, pyodide, molId);
            }
            catch (err) {
                dispatchNotificationEvent({
                    message: "Error updating a system.",
                    type: "error",
                });
            }
        }
        else if (update.action === "syst_visibility") {
            if (!system)
                return;
            const cellRefs = system.cellRef;
            if (!cellRefs)
                return;
            const visibility = update.data;
            setVisibility(molstar, cellRefs, visibility);
            updateStateTreeVisibilityFromCellRefs(vss, cellRefs, visibility, molstar);
        }
        else if (update.action === "syst_focus") {
            if (!system)
                return;
            focusOnSelection(system, molstar, update.data);
        }
    });
}
